import {
  Directive,
  Output,
  ElementRef,
  EventEmitter,
  NgZone,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { HostListener, Renderer2 } from '@angular/core';
import { Subscription, fromEvent } from 'rxjs';

@Directive({
  selector: '[fileDrop]',
})
export class FileDropDirective implements OnInit, OnDestroy {
  @Output() dropped: EventEmitter<File> = new EventEmitter();

  private subscriptions: Subscription[];

  constructor(
    private rendererPrivate: Renderer2,
    private elementRefPrivate: ElementRef,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.subscriptions = [
        this.handleDragOver(),
        this.handleDragEnter(),
        this.handleDragLeaver(),
      ];
    });
  }

  private handleDragOver() {
    return fromEvent(
      this.elementRefPrivate.nativeElement,
      'dragover'
    ).subscribe((event: Event) => {
      const transfer: DataTransfer = (event as DragEvent).dataTransfer;
      transfer.dropEffect = 'copy';
      this._stopEvent(event);
    });
  }

  private handleDragEnter() {
    return fromEvent(
      this.elementRefPrivate.nativeElement,
      'dragenter'
    ).subscribe((event: Event) => {
      this.rendererPrivate.addClass(
        this.elementRefPrivate.nativeElement,
        'drag-drop'
      );
      this._stopEvent(event);
    });
  }

  private handleDragLeaver() {
    return fromEvent(
      this.elementRefPrivate.nativeElement,
      'dragleave'
    ).subscribe((event: Event) => {
      this.rendererPrivate.removeClass(
        this.elementRefPrivate.nativeElement,
        'drag-drop'
      );
      this._stopEvent(event);
    });
  }

  /**
   * Listens to 'drop' host event to get validated transfer items.
   * Emits the 'dropped' event with a [File]
   * Stops event propagation and default action from browser for 'drop' event.
   */
  @HostListener('drop', ['$event'])
  onDrop(event: Event): void {
    const transfer: DataTransfer = (event as DragEvent).dataTransfer;
    const files: FileList = transfer.files;
    if (files.length) {
      const value: File = files[0];
      this.dropped.emit(value);
    }

    this.rendererPrivate.removeClass(
      this.elementRefPrivate.nativeElement,
      'drag-drop'
    );
    this._stopEvent(event);
  }

  private _stopEvent(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions.length = 0;

    if (this.elementRefPrivate) {
      this.elementRefPrivate.nativeElement.src = '';
      this.elementRefPrivate = null;
    }
  }
}
